import { Metric } from "@/entities/Finance/Finance.model";
import dayjs from "dayjs";

interface PeriodColumn {
    field: string;
    headerName: string;
    headerComponent?: any;
    headerComponentParams?: any;
}

export function formatPeriodHeader(period: string): string {
    const date = dayjs(period);
    if (!date.isValid()) return period;

    if (period.length === 4) {
        return period;
    } else if (period.includes("Q")) {
        return period.replace("-", "-").slice(0, -2);
    } else {
        return date.format("MM-YY");
    }
}

export function formatPeriodLong(period: string): string {
    if (period.length === 4) {
        return period;
    }

    if (period.includes("Q")) {
        const match = period.match(/^(\d{4})-?(Q\d)$|^(Q\d)-(\d{2})$/);
        if (match) {
            const quarter = match[2] || match[3];
            const year = match[1] || `20${match[4]}`;
            return `${quarter} ${year}`;
        }
        return period;
    }

    const date = dayjs(period);
    if (!date.isValid()) return period;
    return date.format("MMMM YYYY");
}

export function getPeriodRange(periods: string[]): string {
    const parsed = periods.map(formatPeriodLong);
    if (parsed.length === 1) return parsed[0];
    return `${parsed[0]} - ${parsed[parsed.length - 1]}`;
}

export function sortPeriods(periods: string[]): string[] {
    return periods.sort((a, b) => a.localeCompare(b));
}

export function formatPeriods(periods: string[]): string[] {
    return periods.map(formatPeriodLong);
}
export function getPeriodColumns(periods: string[]): PeriodColumn[] {
    return periods.map((period) => ({
        field: period,
        headerName: formatPeriodHeader(period),
    }));
}

export function getUniquePeriods(metrics: Metric[]): string[] {
    return [
        ...new Set(
            metrics
                .map((metric) => metric.values.map((value) => value.period))
                .flat(),
        ),
    ];
}
